import { Text, TextStyle, Sprite, Container } from "pixi.js";
import { GameFont } from "../../../common/GameFont";
import { PriceHistoryResourcePackage } from "../resources/PriceHistoryResourcePackage";
import { PurchaseHistory } from "../../marketplace/main/models/building/PurchaseHistory";
import { StringFormatExtention } from "../../../../../extensions/StringFormatExtention";

export class PriceHistoryItem extends Container {
    private static readonly NAME_MAX_LENGTH = 9;
    private static readonly TEXT_POSITION_POINTS = {
        first: 100,
        second: 285,
        third: 483,
        fourth: 668
    }

    private textBox: Container;
    private dateText: Text;
    private priceText: Text;
    private sellerText: Text;
    private buyerText: Text;
    private devider: Sprite;

    public constructor(
        private readonly priceHistoryResources: PriceHistoryResourcePackage,
        private readonly history: PurchaseHistory
    ) {
        super();
        this.build();
        this.layout();
    }

    private build(): void {
        this.textBox = new Container();
        this.dateText = new Text(this.dateFormat(), new ItemTextStyle());
        const price = this.history.price.usd != null ? this.history.price.usd.toFixed(2) : this.history.price.mon.toFixed(2);
        const currency = this.history.price.usd != null ? "$" : "MON";
        this.priceText = new Text(`${currency}${StringFormatExtention.formatWithComma(price)}`, new ItemYellowTextStyle());
        this.sellerText = new Text(this.trimUsername(this.history.sender.name.toUpperCase()), new ItemTextStyle());
        this.buyerText = new Text(this.trimUsername(this.history.receiver.name.toUpperCase()), new ItemTextStyle());
        this.textBox.addChild(this.dateText, this.priceText, this.sellerText, this.buyerText);
        this.devider = new Sprite(this.priceHistoryResources.assets_views_price_history_devider_png);
        this.addChild(this.textBox, this.devider);
    }

    private layout(): void {
        this.dateText.position.x = PriceHistoryItem.TEXT_POSITION_POINTS.first - this.dateText.width * 0.5;
        this.priceText.position.x = PriceHistoryItem.TEXT_POSITION_POINTS.second - this.priceText.width * 0.5;
        this.sellerText.position.x = PriceHistoryItem.TEXT_POSITION_POINTS.third - this.sellerText.width * 0.5;
        this.buyerText.position.x = PriceHistoryItem.TEXT_POSITION_POINTS.fourth - this.buyerText.width * 0.5;
        this.devider.position.set(0, this.textBox.height + 40);
    }

    private dateFormat(): string {
        const dateObj = new Date(this.history.date);
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, "0");
        const day = String(dateObj.getDate()).padStart(2, "0");
        return `${month}.${day}.${year}`;
    }

    private trimUsername(name: string) {
        if (name.length > PriceHistoryItem.NAME_MAX_LENGTH) {
            return name.substring(0, PriceHistoryItem.NAME_MAX_LENGTH) + "...";
        }
        return name;
    }
}

class ItemTextStyle extends TextStyle {
    public constructor() {
        super(
            new TextStyle({
                align: "center",
                fill: "#ffffff",
                fontFamily: GameFont.DEFAULT_FONT,
                fontSize: 37,
            })
        );
    }
}

class ItemYellowTextStyle extends TextStyle {
    public constructor() {
        super(
            new TextStyle({
                align: "center",
                fill: "#FFC700",
                fontFamily: GameFont.DEFAULT_FONT,
                fontSize: 37,
            })
        );
    }
}
